// @flow
import mediatorChannels from "@tvg/mediator";
import pushToDataLayer from "../gtmUtils";

export default () => {
  mediatorChannels.base.subscribe("RACEPAGE_DETAILS_EXPANDED", () => {
    pushToDataLayer({
      event: "siteClick",
      gaEventCategory: "Site Click",
      gaEventAction: "Tags Expanded",
      gaEventLabel: "horse_details",
      module: "horse_details",
      tag: undefined
    });
  });
};
